import React from 'react';
import UpdateLayout from './UpdateLayout';
import { CORTEX_GATEWAY_SOURCES, OCTOBER_19_NOTE_AS_OF } from '../../../content/snowflakeUpdates';

export default function CortexGatewayAzurePost() {
  return (
    <UpdateLayout
      path="/updates/cortex-ai-gateway-azure"
      title="Cortex AI Gateway lands on Azure: what it means for Power BI shops"
      asOf={OCTOBER_19_NOTE_AS_OF}
      sources={CORTEX_GATEWAY_SOURCES}
    >
      <p>
        On October 16, 2026, Snowflake expanded Cortex AI Gateway to Azure and GCP commercial
        regions, and to the AWS Asia Pacific (New Zealand) region. It remains in public preview.
      </p>
      <p>
        That opens the gateway to customers whose Snowflake account runs on Azure, including teams
        using Power BI and Microsoft Fabric. Model access stays governed in the customer&apos;s
        account.
      </p>

      <h2 className="pt-2 font-display text-2xl font-semibold tracking-tight text-brand-900">
        What to check
      </h2>
      <ol className="list-decimal space-y-3 pl-5">
        <li>
          <span className="font-semibold text-ink-900">Check the region and the preview status.</span>{' '}
          Confirm the account is in a region where the gateway is available, and that the feature is
          still in preview, before you plan on it.
        </li>
        <li>
          <span className="font-semibold text-ink-900">Review governance and grants.</span> Confirm
          which roles can use the gateway, and which models those roles are already allowed to reach.
        </li>
        <li>
          <span className="font-semibold text-ink-900">Test in a non-prod account.</span> Run the
          check against a non-prod Snowflake account before you change production grants.
        </li>
        <li>
          <span className="font-semibold text-ink-900">Keep model access governed.</span> Leave model
          access inside the customer&apos;s account. Do not add a grant only to reach a model the
          account has not already approved.
        </li>
      </ol>
    </UpdateLayout>
  );
}
